import { createCommand, NodeKey } from 'lexical';
import type { RawHtmlTableCellStyle, RawHtmlTableStyle, RawHtmlTableStylePresetName } from './tableStyle';

export type RawHtmlStylePatch<T> =
{
    [K in keyof T]?: T[K] | null | undefined;
}

export type PatchRawHtmlTableStylePayload =
{
    tableKey?: NodeKey
    patch: RawHtmlStylePatch<RawHtmlTableStyle>
}

export type PatchRawHtmlTableCellStylePayload =
{
    tableKey?: NodeKey
    cellKeys?: NodeKey[]
    patch: RawHtmlStylePatch<RawHtmlTableCellStyle>
}

export type ApplyRawHtmlTablePresetPayload =
{
    tableKey?: NodeKey
    presetName: RawHtmlTableStylePresetName
}

export const APPLY_RAW_HTML_TABLE_PRESET_COMMAND =
    createCommand<ApplyRawHtmlTablePresetPayload>('APPLY_RAW_HTML_TABLE_PRESET_COMMAND');

export const PATCH_RAW_HTML_TABLE_STYLE_COMMAND =
    createCommand<PatchRawHtmlTableStylePayload>('PATCH_RAW_HTML_TABLE_STYLE_COMMAND');

export const PATCH_RAW_HTML_TABLE_CELL_STYLE_COMMAND =
    createCommand<PatchRawHtmlTableCellStylePayload>('PATCH_RAW_HTML_TABLE_CELL_STYLE_COMMAND');